import { render, staticRenderFns } from "./RegisterArbitro.vue?vue&type=template&id=6fc80b97&"
import script from "./RegisterArbitro.vue?vue&type=script&lang=js&"
export * from "./RegisterArbitro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports